import React, { Component } from 'react';
import { Container, Row, Col } from "reactstrap";

import logo from "../../assets/images/logo-niec-white.png";

import FooterLink from "./footer-link";
import LinkSection from "./link-section";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa6";
import { FaMapLocationDot } from "react-icons/fa6";

class Footer extends Component {
    state = {
        links1 : [
            { link : "https://niecindonesia.com/", title : "Website" },
            { link : "http://prioritas.niecindonesia.com/", title : "Prioritas Member" },
            { link : "http://ambassador.niecindonesia.com/", title : "Global Ambassador" }
        ],
        socials : [
            { class : "bg-twitter", icon : <FaXTwitter />, link : "https://twitter.com/NIEC_Indonesia" },
            { class : "bg-dribbble", icon : <FaInstagram />, link : "https://www.instagram.com/niec_indonesia/" },
            { class : "bg-googleplus", icon : <FaYoutube />, link : "https://www.youtube.com/channel/UCA5qiOgJdfMvADpyU7Oz7fQ" },
            { class : "bg-facebook", icon : <FaFacebookF />, link : "https://www.facebook.com/Naresy-International-Education-Consultant-578610318865001" },
        ],
        office : [
            { address : "Denpasar - Jl. Buluh Indah No.56, Pemecutan Kaja", map : "https://maps.app.goo.gl/gUN8RdMAPZrRVsK56" },
            { address : "Medan - GoWork Sinar Mas Land Plaza, Jl. Pangeran Diponegoro No.18 Lt. 10", map : "https://maps.app.goo.gl/NFxTmK5atZyvtuTF7" },
            { address : "Jakarta - Kantor MULA - Office & Commercial Space, Jl. Kemang Sel. Raya No.151, Pasar Minggu", map : "https://maps.app.goo.gl/t5GXgtZc3hFgyrWA9" },
            { address : "Tangerang - Sanctuary Bintaro, Ruko Emerald Boulevard Bintaro Sektor 9 Blok AA2 No. 50, Banten", map : "https://maps.app.goo.gl/G7cFaA3dYKbiAfcx6" },
            { address : "Bandung - Point Lab Co-working Space, Jl. Banda No.30", map : "https://maps.app.goo.gl/g6nA72wucc9PzjX6A" },
            { address : "Yogyakarta - Jl. Bintaran Kidul No.36, Wirogunan, Kec. Mergangsan, Kota Yogyakarta", map : "https://maps.app.goo.gl/vFJ5KkCvh2Tfi3aK9" },
            { address : "Makassar - Bikin Bikin Creative Hub Mall Nipah, Jl. Urip Sumoharjo No.23C, Panakkukang", map : "https://maps.app.goo.gl/b4ZkZrm4sNuHQ63E8" },
            { address : "Surabaya - IdeaHub Coworking Space, Voza Tower, Jl. Mayjen HR. Muhammad No.31, Putat Gede", map : "https://maps.app.goo.gl/9cR1bZhCH9mMzYE56" },
        ],
        icons : <FaMapLocationDot />
    }
    render() {
        return (
            <React.Fragment>
                <footer id='footer' className="footer">
                    <Container>
                        <Row>
                            {/* <Col md="4" sm="12">
                                <img src={logo} alt="logo" width='120' height="55" />
                                <p className="margin-t-20" style={{color: 'white'}}><strong>NIEC Indonesia adalah konsultan pendidikan luar negeri yang membantu pencarian sekolah/college/universitas di Luar Negeri dan telah berpengalaman lebih dari 12 tahun.</strong></p>

                                <ul className="list-inline social">
                                    {
                                        this.state.socials.map((social, key) =>
                                            <li key={key} className="list-inline-item">
                                                <a className={social.class + " mr-1"} rel='noreferrer' href={social.link} target='_blank' style={{color: 'white'}}><i className={social.icon}></i></a>
                                            </li>
                                        )
                                    }
                                </ul>
                            </Col>
                            <Col md={{size:3, offset : 2}} sm="6" style={{color: 'white'}}>
                                <LinkSection title="Links" links={this.state.links1} />
                            </Col> */}
                          <Col md="8">
                            <h3>NIEC Office</h3>
                            <ul>
                              {
                                this.state.office.map((data, id) =>
                                  <li key={id} className='pb-2'> 
                                    {this.state.icons}
                                    <a href={data.map} target='_blank' rel="noopener noreferrer"> {data.address} </a>
                                  </li>
                                ) 
                              }
                            </ul>
                          </Col>
                          <Col md="4">
                            <h3>Social Connection</h3>
                                <ul className="list-inline social">
                                    {
                                        this.state.socials.map((social, key) =>
                                            <li key={key} className="list-inline-item">
                                                <a className={social.class + " mr-1"} rel='noreferrer' href={social.link} target='_blank' style={{color: 'white'}}>{social.icon}</a>
                                            </li>
                                        )
                                    }
                                </ul>
                          </Col>
                        </Row>
                    </Container>
                </footer>
                <FooterLink/>
            </React.Fragment>
        );
    }
}

export default Footer;